<template>
  <RestyleModal
    @close="setIsVisibleModalReportTransporterValue(false)"
    @cancel="setIsVisibleModalReportTransporterValue(false)"
    @save="downloadReport"
    :sendDisabled="disabledDownloadButton"
  >
    <template v-slot:header >
      Отчёт оценка перевозчика
    </template>
    <div class="" style="min-height: 350px">
      <div class="mb-4">
        <DateRangePicker
          @dateChange="dateChange"
          :dates="dateRange"
          :dateSelectBoxStyle="dateSelectBoxStyle"
          :minDate="minDate"
          :maxDate="maxDate"
          :canClearDate="false"
          class="date-filter me-4"
          />
      </div>
      <div>
        <SearchFilterMultiSelect
          :allSelectOptions="computedUserOrganisations"
          :inputText="searchUserOrganisation"
          @inputChange="searchUserOrganisation = $event"
          @selectedOptionsChange="selectedUserOrganisation = $event"
          :selectedOptions="selectedUserOrganisation"
          placeholder="Организации"
          :wordForms="['организация', 'организации', 'организаций']"
          :wordFormsSelected="['Выбрана', 'Выбрано', 'Выбрано']"
          class="text-left me-4"
          style="width: 280px"
        />
      </div>
    </div>
    <template v-slot:confirmButtonText >Скачать</template>
  </RestyleModal>
</template>

<script>

import { request } from "@/_helpers";
import DateRangePicker from "@/components/restyle/calendar/DateRangePicker.vue";
import { mapGetters, mapMutations } from "vuex";
import { transformOrgsIntoOrgTree } from "@/_helpers/functions/functions";
import SearchFilterMultiSelect from "@/components/restyle/primitives/filters/SearchFilterMultiSelect.vue";

export default {
  name: 'ReportTransporterEvaluation',
  components: {
    DateRangePicker,
    SearchFilterMultiSelect,
  },
  data() {
    return {
      minDate: null,
      maxDate: null,
      dateSelectBoxStyle: { width: "300px", height: "unset" },
      dateRange: {
        start: null,
        end: null,
      },
      searchUserOrganisation: "",
      selectedUserOrganisation: [],
      isLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      userOrganisations: "user/userOrganisations",
    }),
    normalizeDateToAddInUrl() {
      const splitDateStart = this.dateRange.start?.split(".");
      const splitDateEnd = this.dateRange.end?.split(".");
      const result = {
        start: `${splitDateStart[2]}-${splitDateStart[1]}-${splitDateStart[0]}`,
        end: `${splitDateEnd[2]}-${splitDateEnd[1]}-${splitDateEnd[0]}`,
      };
      return result;
    },
    computedUserOrganisations () {
      let result = transformOrgsIntoOrgTree(this.userOrganisations)
      result = result.reduce((acc, item) => {
        acc.push(item)

        if (item.children?.length > 0) {
          for (const iterator of item.children) {
            acc.push({...iterator, itsChild: true})
          }
        }

        return acc
      }, [])
      
      return result
    },
    disabledDownloadButton() {
      return this.selectedUserOrganisation.length === 0 || !this.dateRange.start || !this.dateRange.end || this.isLoading;
    },
  },
  methods: {
    ...mapMutations({
      setIsVisibleModalReportTransporterValue: "reports/set_is_visible_modal_report_transporter_value"
    }),
    downloadReport() {
      let url = new URL(`${process.env.VUE_APP_WN}/fact/platform/evaluation_report`);
      url.searchParams.append("api_token", localStorage.getItem("auth_token"));
      url.searchParams.append("begin_date", this.normalizeDateToAddInUrl.start);
      url.searchParams.append("end_date", this.normalizeDateToAddInUrl.end);
      this.selectedUserOrganisation.forEach((element, index) => {
        url.searchParams.append(`organisation_ids[]`, element.id);
      });
      this.isLoading = true;
      request(url.href, "GET")
      .then((res) => {
        this.$store.dispatch('alert/alerts', { type: 'success', message: res.message });
      })
      .finally(() => {
        this.isLoading = false;
      })
    },
    dateChange(event) {
      this.dateRange = event;
    },
  },
}
</script>

<style lang="scss" scoped>

</style>